import { gateNames, useCurrentUser, useGate } from '@mp';
import { MenuItem } from '@medely/web-components';
import React from 'react';
import { SettingsMenuItemsProps } from '../SettingsDropdown';
import { useHistory } from 'react-router';
import { ReferralContainer } from '@src/components/referrals/ReferralContainer';

export const MarketplaceSettingsMenu = ({ handleClose }: SettingsMenuItemsProps) => {
  const { isDeactivated, isApplicant, isMarketplace } = useCurrentUser();
  const history = useHistory();
  const referralLinkGate = useGate(gateNames.referralLinkGate);
  const showReferralLink = referralLinkGate && !isDeactivated && isMarketplace;

  return (
    <>
      {!isApplicant && (
        <>
          {!isDeactivated && (
            <MenuItem
              onClick={() => {
                history.push('/profile');
                handleClose();
              }}
            >
              My Profile
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              history.push('/settings');
              handleClose();
            }}
          >
            Settings
          </MenuItem>
        </>
      )}
      {showReferralLink && (
        <MenuItem
          onClick={() => {
            handleClose();
          }}
        >
          <ReferralContainer isPopup />
        </MenuItem>
      )}
    </>
  );
};
